import React from 'react';
import { PiletApi } from '@sharefiledev/sharefile-appshell';
import { storageExtensionSlots } from '@sharefiledev/storage-plugin-pilet';
import { DESKTOP_SHARE_MODEL_PATH } from '../../utils/constants';

interface DesktopShareModalParams {
	piletApi: PiletApi;
}

export const DesktopShareModal: React.FC<DesktopShareModalParams> = ({ piletApi }) => {
	const versionAgnosticId = location.pathname.split(`${DESKTOP_SHARE_MODEL_PATH}/`)[1];
	const params = {
		containerRID: null,
		versionAgnosticId,
	};
	const pilet: any = piletApi;
	return <pilet.Extension name={storageExtensionSlots.ShareModal} params={params} />;
};
